// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:product:vL9l9y */\n.EiDpF{display:flex;flex-direction:column;font-family:var(--font-muse-sans);gap:var(--audio-spacing-8);padding:var(--audio-spacing-48) var(--audio-spacing-16);text-align:center}._7X-46{color:var(--audio-content-primary);font-size:var(--audio-font-size-16);font-weight:600;margin:0}.XKPnQ{color:var(--audio-content-secondary);font-size:var(--audio-font-size-14);margin:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"empty": "EiDpF",
	"title": "_7X-46",
	"description": "XKPnQ"
};
export default ___CSS_LOADER_EXPORT___;
